import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  DatePicker,
  Button,
  Form,
  Row,
  Col,
  InputNumber,
  Spin,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import useCommonsService from "../../../../services/useCommonsService";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";
import LocationPicker from "../../../Firms/CreateEditAdvert/Components/LocationPicker";

const { TextArea } = Input;

const PersonnelInfo = ({ personnelInfo }) => {
  const [isCitySelectVisible, setIsCitySelectVisible] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [locationData, setLocationData] = useState({
    latitude: null,
    longitude: null,
    address: "",
  });

  const { useUpdatePersonalInformation } = usePersonnelInfoService();
  const { mutateAsync: updatePersonalInformation, isPending: isUpdateLoading } =
    useUpdatePersonalInformation();

  const {
    useMaritalStatutes,
    useGetAllSectors,
    cities,
    useGetAllCountries,
    useGenders,
    isLoadingCities,
    useDistricts,
  } = useCommonsService();

  const { data: districts, isLoading: isLoadingDistricts } =
    useDistricts(selectedCityId);
  const { data: sectors } = useGetAllSectors();
  const { data: maritalStatuses } = useMaritalStatutes();
  const { data: countries } = useGetAllCountries();
  const { data: genders } = useGenders();

  const [form] = useForm();
  console.log("personel info", personnelInfo);

  useEffect(() => {
    setSelectedCityId(personnelInfo.personnelAddress?.district.city.id);
    setIsCitySelectVisible(personnelInfo.countryToWork?.name === "Türkiye");
    setLocationData({
      latitude: personnelInfo.personnelAddress?.coordinate?.latitude,
      longitude: personnelInfo.personnelAddress?.coordinate?.longitude,
      address: personnelInfo.personnelAddress?.address,
    });
    form.setFieldsValue({
      name: personnelInfo.name,
      surname: personnelInfo.surname,
      email: personnelInfo.email,
      summary: personnelInfo.summary,
      phoneNumber: personnelInfo.phoneNumber,
      gender: personnelInfo.gender.name,
      birthDate: dayjs(personnelInfo.birthDate),
      birthPlace: personnelInfo.birthPlace,
      maritalStatus: personnelInfo.maritalStatus?.name,
      countryToWorkId: personnelInfo.countryToWork?.id,
      cityToWorkId: personnelInfo?.cityToWork?.id,
      cityId: personnelInfo.personnelAddress?.district?.city?.id,
      districtId: personnelInfo.personnelAddress?.district?.id,
      location: {
        latitude: personnelInfo.personnelAddress?.coordinate?.latitude,
        longitude: personnelInfo.personnelAddress?.coordinate?.longitude,
        address: personnelInfo.personnelAddress?.address,
      },
      // address: personnelInfo.personnelAddress?.address,
      // latitude: personnelInfo.personnelAddress?.coordinate?.latitude,
      // longitude: personnelInfo.personnelAddress?.coordinate?.longitude,
      sectorIds: personnelInfo.personnelSectors.map((item) => {
        return item.sector.id;
      }),
    });
  }, [personnelInfo]);

  const handleCountryChange = (value, option) => {
    if (option?.label === "Türkiye") {
      setIsCitySelectVisible(true);
    } else {
      form.setFieldsValue({ cityToWorkId: null });
      setIsCitySelectVisible(false);
    }
  };

  const handleCityChange = (value) => {
    setSelectedCityId(value);
    form.setFieldValue("districtId", undefined);
  };

  const handleLocationChange = (newLocation) => {
    setLocationData(newLocation);
    form.setFieldsValue({ location: newLocation });
  };

  const handleSavePersonnelInformation = (values) => {
    const requestBody = {
      birthDate: dayjs(values.birthDate).format("YYYY-MM-DD"),
      name: values.name,
      surname: values.surname,
      email: values.email,
      summary: values.summary,
      birthPlace: values.birthPlace,
      gender: values.gender,
      maritalStatus: values.maritalStatus,
      sectorIds: values.sectorIds,
      countryToWorkId: values.countryToWorkId,
      cityToWorkId: values.cityToWorkId,
      address: values.location.address,
      districtId: values.districtId,
      latitude: values.location.latitude,
      longitude: values.location.longitude,
    };

    try {
      updatePersonalInformation(requestBody);
    } catch (error) {
      console.error("Error updating personal information:", error);
    }
  };

  return (
    <Spin spinning={isUpdateLoading}>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSavePersonnelInformation}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="İsim"
              name="name"
              rules={[
                { required: true, message: "Lütfen isim soyisim giriniz" },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Soyisim"
              name="surname"
              rules={[
                { required: true, message: "Lütfen isim soyisim giriniz" },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Telefon"
              name="phoneNumber"
              rules={[
                { required: true, message: "Lütfen telefon numarası giriniz" },
              ]}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="E-posta"
              name="email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Lütfen geçerli bir e-posta giriniz",
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Kendin Hakkında Özet Bilgi"
          name="summary"
          // rules={[
          //   { required: true, message: "Lütfen kendiniz hakkında bilgi giriniz" },
          // ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Doğum Yeri"
              name="birthPlace"
              rules={[
                { required: true, message: "Lütfen doğum yerinizi giriniz" },
              ]}>
              <Input></Input>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Doğum Tarihi"
              name="birthDate"
              rules={[
                { required: true, message: "Lütfen doğum tarihi seçiniz" },
              ]}>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Cinsiyet"
              name="gender"
              rules={[{ required: true, message: "Lütfen cinsiyet seçiniz" }]}>
              <Select options={genders} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Medeni Hal"
              name="maritalStatus"
              rules={[
                { required: true, message: "Lütfen medeni hal seçiniz" },
              ]}>
              <Select options={maritalStatuses}></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={12}></Col>
          <Col></Col>
        </Row>

        <Form.Item
          label="Çalışmak İstediği Sektörler"
          name="sectorIds"
          rules={[
            { required: true, message: "Lütfen en az bir sektör seçiniz" },
          ]}>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Sektör seçiniz"
            options={sectors}></Select>
        </Form.Item>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Çalışmak İstediği Ülke"
              name="countryToWorkId"
              rules={[{ required: true, message: "Lütfen ülke seçiniz" }]}>
              <Select
                showSearch
                onChange={handleCountryChange}
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={countries}></Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Çalışmak İstediğiniz Şehir"
              name="cityToWorkId"
              // rules={[{ required: true, message: "Lütfen şehir seçiniz" }]}
            >
              <Select
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                disabled={!isCitySelectVisible}
                options={cities}></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Adres/Şehir"
              name="cityId"
              rules={[{ required: true, message: "Lütfen ülke seçiniz" }]}>
              <Select
                showSearch
                onChange={handleCityChange}
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={cities}></Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Adres/İlçe"
              name="districtId"
              rules={[{ required: true, message: "Lütfen şehir seçiniz" }]}>
              <Select
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                loading={isLoadingDistricts}
                disabled={!selectedCityId}
                options={districts}></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              label="Konum"
              name="location"
              rules={[{ required: true, message: "Lütfen konum seçiniz" }]}>
              <LocationPicker
                value={locationData}
                onChange={handleLocationChange}
                isAdvertCreateOrEdit={false}
                initialLocation={locationData}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default PersonnelInfo;
